import { PAYMENT_PROCESS, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    paymentProcess: false
}

export const paymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case PAYMENT_PROCESS:
            return {
                ...state,
                paymentProcess: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}